import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(0.25, 0.75),
    fontWeight: theme.typography.fontWeightBold,
  },
});

const AuthenticationFactorListItemActionRegister = ({
  className,
  classes,
  authenticationFactorResource,
}) => {
  const { loadModalCollectionByLink } = useModalContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <Button
      className={classNames(classes.root, className)}
      variant={'outlined'}
      onClick={() => {
        logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Authentication Factor turn on', {
          eventProperties: {
            authenticationType: authenticationFactorResource.attr('authenticationType'),
          },
        });
        loadModalCollectionByLink(authenticationFactorResource.relationship(fr.relationships.authenticationFactorRegister.name).link('related').url());
      }}
      test={`security-settings-button-${authenticationFactorResource.attr('authenticationType')}-register`}
    >
      {'Turn on'}
    </Button>
  );
};

AuthenticationFactorListItemActionRegister.defaultProps = {
  className: '',
};

AuthenticationFactorListItemActionRegister.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthenticationFactorListItemActionRegister);
